function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.88721,
  y: 2.5,
  width: 29,
  height: 29,
  rx: 14.5,
  fill: "#9FABBB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5716 16.9794L21.8328 13.7183C22.1351 13.3938 22.1262 12.8881 21.8126 12.5745C21.499 12.2609 20.9933 12.252 20.6688 12.5544L17.4077 15.8155L14.2165 12.6244C14.0112 12.404 13.702 12.3133 13.4102 12.3879C13.1184 12.4624 12.8906 12.6902 12.8161 12.982C12.7416 13.2738 12.8323 13.583 13.0526 13.7883L16.2438 16.9794L12.9826 20.2406C12.7623 20.4459 12.6716 20.7551 12.7461 21.0469C12.8206 21.3387 13.0484 21.5665 13.3402 21.641C13.632 21.7155 13.9412 21.6249 14.1465 21.4045L17.4077 18.1434L20.5988 21.3345C20.8041 21.5549 21.1133 21.6455 21.4051 21.571C21.6969 21.4965 21.9247 21.2687 21.9993 20.9769C22.0738 20.6851 21.9831 20.3759 21.7628 20.1706L18.5716 16.9794Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5716 16.9794L21.8328 13.7183C22.1351 13.3938 22.1262 12.8881 21.8126 12.5745C21.499 12.2609 20.9933 12.252 20.6688 12.5544L17.4077 15.8155L14.2165 12.6244C14.0112 12.404 13.702 12.3133 13.4102 12.3879C13.1184 12.4624 12.8906 12.6902 12.8161 12.982C12.7416 13.2738 12.8323 13.583 13.0526 13.7883L16.2438 16.9794L12.9826 20.2406C12.7623 20.4459 12.6716 20.7551 12.7461 21.0469C12.8206 21.3387 13.0484 21.5665 13.3402 21.641C13.632 21.7155 13.9412 21.6249 14.1465 21.4045L17.4077 18.1434L20.5988 21.3345C20.8041 21.5549 21.1133 21.6455 21.4051 21.571C21.6969 21.4965 21.9247 21.2687 21.9993 20.9769C22.0738 20.6851 21.9831 20.3759 21.7628 20.1706L18.5716 16.9794Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1977:7017)"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 2.88721,
  y: 2.5,
  width: 29,
  height: 29,
  rx: 14.5,
  stroke: "#EAEEF4",
  strokeWidth: 5
});

function SvgIconStatusDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1977:7017",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 11,
    height: 10
  }, _ref4), _ref5, _ref6);
}

var ForwardRef = React.forwardRef(SvgIconStatusDisabled);
export default __webpack_public_path__ + "static/media/icon-status-disabled.1982b33c.svg";
export { ForwardRef as ReactComponent };